module.exports = __webpack_public_path__ + "img/button-b-misc-03-calendars.bf3a32f4.png";